import BaseRequest from './index'
import {
  UPDATE_PROFILE,
  POST_NEXTOFKIN,
  UPDATE_PROFILEPIC,
  CHANGE_PASWWORD,
  PIN_RESET,
  GET_NEXTOFKIN,
  PIN_CREATE,
} from './api'
import {
  UpdateProfileDto,
  UpdateNextOfkinDto,
  PictureDto,
  ChangePasswordDto,
  ResetPinDto,
  CreatePinDto,
} from './types'

class ProfileService extends BaseRequest {
  constructor() {
    super()
    this.bindMethods()
  }
  bindMethods() {
    this.updateProfile = this.updateProfile.bind(this)
    this.updateProfile = this.updateProfile.bind(this)
    this.updateNextOfKin = this.updateNextOfKin.bind(this)
    this.updateAvatar = this.updateAvatar.bind(this)
    this.updatePassword = this.updatePassword.bind(this)
    this.resetPin = this.resetPin.bind(this)
    this.createPin = this.createPin.bind(this)
  }
  async updateProfile<T>(data: UpdateProfileDto): Promise<T> {
    return await this.api.put(UPDATE_PROFILE, data)
  }
  async updateNextOfKin<T>(data: UpdateNextOfkinDto): Promise<T> {
    return await this.api.post(POST_NEXTOFKIN, data)
  }
  async updateAvatar<T>(data: PictureDto): Promise<T> {
    return await this.api.put(UPDATE_PROFILEPIC, data)
  }
  async updatePassword<T>(data: ChangePasswordDto): Promise<T> {
    return await this.api.post(CHANGE_PASWWORD, data)
  }
  async resetPin<T>(data: ResetPinDto): Promise<T> {
    return await this.api.put(PIN_RESET, data)
  }
  async createPin<T>(data: CreatePinDto): Promise<T> {
    return await this.api.post(PIN_CREATE, data)
  }
  async getNextOfKin<T>(): Promise<T> {
    return await this.api.get(GET_NEXTOFKIN)
  }
}
const profileService = new ProfileService()

export default profileService
